import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Typography, Box, IconButton, } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ReactComponent as Edit } from "../../../../assets/images/edit.svg";
import styles from "./style";
import CustomPagination from "../../../../components/CustomPagination";
import Modal from "../../../../components/Modal";
import { formatDate } from "../../../../utils/DateFormat";


const TimesheetList = ({ data, handleDeleteEmployee, setOpen, setFrom, setItem, page, setPage, total }) => {


  const [open, setopen] = useState(false);
  const [value, setValue] = useState();

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const deleteData = (item) => {
    setValue(item);
  }
  const handleDeleteItem = () => {
    handleDeleteEmployee(value); // Call the delete function passed as prop
    setopen(false); // Close the modal after deleting
  };

  function getTotalMinutes(work) {
    // Sum all minutes and convert to hours
    const totalHours = work.reduce((total, item) => total + (Number(item.minutes) || 0) / 60, 0);
    return parseFloat(totalHours).toFixed(2); // Return hours with 2 decimal places
  }

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  const handleNavigate = (item) => {
    setItem({
      ...item,
      work: item.work.map(workItem => ({
        project: workItem.project,
        hours: workItem.hours,
        minutes: workItem.minutes // Ensure only minutes is included
      }))
    });
    setOpen(true);
    setFrom("edit");
  };

  return (
    <>
      <TableContainer sx={styles.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableHead}>Employee</TableCell>
              <TableCell sx={styles.tableHead}>Date</TableCell>
              <TableCell sx={styles.tableHead}>Project Name</TableCell>
              <TableCell sx={styles.tableHead}>Hours</TableCell>
              <TableCell sx={styles.tableHead}>Status</TableCell>
              <TableCell sx={styles.tableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.map((item, index) => {
                return (<TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src={item?.employeeDetails?.personalInfo?.image} sx={styles.profileAvtar} />
                    <Box>
                      <Typography sx={styles.name}>{item?.employeeDetails?.personalInfo?.firstName} {item?.employeeDetails?.personalInfo?.surName}</Typography>
                      <Typography sx={styles.mail}>Employee ID:{item?.employeeDetails?.stafId}</Typography>
                    </Box>

                  </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.date && formatDate(item.date)}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.work[0]?.project}
                    {item?.work.length > 1 && <Avatar sx={{ fontSize: "12px", fontWeight: "600", ml: 1, width: "24px", height: "24px" }} sizes="small">{`+${item?.work.length - 1}`}</Avatar>}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.work?.[0]?.hours}</TableCell>
                  <TableCell sx={styles.tabledata}><Box sx={{
                    border: `1px solid ${item.status === "Approved" ? "green" :
                      item.status === "Rejected" ? "red" :
                        item.status === "Pending" ? "#F4B63F" :
                          item.status === "Weekend" ? "#00ABF4" :
                            "#F4B63F"}`,
                    borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center", py: "5px", px: "14px", width: "fit-content",
                    color: `${item.status === "Approved" ? "#28AA4A" :
                      item.status === "Rejected" ? "red" :
                        item.status === "Pending" ? "#F4B63F" :
                          item.status === "Weekend" ? "#00ABF4" :
                            "#F4B63F"}`
                  }}>{item.status || "Pending"}</Box></TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      <IconButton sx={{ mb: 1 }}>
                        <Edit onClick={() => { handleNavigate(item); }} />
                      </IconButton>
                      <DeleteOutlineIcon sx={{ color: "#ff0000", mb: 1, ml: 2 }} onClick={() => {
                        deleteData(item?._id), setopen(true);
                      }} />
                    </Box>
                  </TableCell>
                </TableRow>);
              })
            )}
          </TableBody>

        </Table>
        {data &&
          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}

      </TableContainer>


      <Modal open={open} setOpen={setopen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Timesheet Data"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>    </>
  );
};
export default TimesheetList;
